import { css, html, LitElement } from "lit"
import "@luminecence/composants/BoutonsSegmente"
import "@luminecence/composants/BoutonSegmente"
import "./PageMaRecherche.js"
import "./PageMesEchanges.js"

export default class PageRecherche extends LitElement {
  static properties = { mode: { type: String } }

  static styles = css`
        :host {
            display: flex;
            flex-direction: column;
            gap: 2rem;
            padding-top: 2rem;
        }
    `

  constructor() {
    super()
    /** @type {"recherche" | "echange"} */
    this.mode = "recherche"
  }

  render() {
    return html`<p-boutons-segmente @evenementSelectionBoutonSegmente=${(event) => (this.mode = event.detail.valeur)}>
            <p-bouton-segmente valeur="recherche" ?selectionne=${this.mode === "recherche"} texte="Recherche"></p-bouton-segmente>
            <p-bouton-segmente valeur="echange" ?selectionne=${this.mode === "echange"} texte="Echange"></p-bouton-segmente>
        </p-boutons-segmente>
        
        ${this.mode === "recherche" ? html`<p-page-ma-recherche></p-page-ma-recherche>` : html`<p-page-mes-echanges></p-page-mes-echanges>`}
        `
  }
}
customElements.define("p-page-recherche", PageRecherche)
